'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CHANNEL_PROFILE_ERROR_HANDLED = exports.RESET_CHANNEL_STATE = exports.DELETE_CHANNEL_GROUP_COMPLETE = exports.DELETE_CHANNEL_GROUP_START = exports.PUT_TO_CHANNEL_GROUP_FAILURE = exports.PUT_TO_CHANNEL_GROUP_COMPLETE = exports.PUT_TO_CHANNEL_GROUP_START = exports.PUT_TO_FEATURE_CONTENT_FAILURE = exports.PUT_TO_FEATURE_CONTENT_COMPLETE = exports.PUT_TO_FEATURE_CONTENT_START = exports.POST_CHANNEL_GROUP_FAILURE = exports.POST_CHANNEL_GROUP_COMPLETE = exports.POST_CHANNEL_GROUP_START = exports.PUT_TO_ADD_CONTENT_FAILURE = exports.PUT_TO_ADD_CONTENT_START = exports.PUT_TO_ADD_CONTENT_COMPLETE = exports.MOVE_CONTENTS_ANOTHER_GROUP_COMPLETE = exports.MOVE_CONTENTS_ANOTHER_GROUP_START = exports.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_FAILURE = exports.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_COMPLETE = exports.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_START = exports.PUT_TO_MOVE_CONTENT_NEW_GROUP_FAILURE = exports.PUT_TO_MOVE_CONTENT_NEW_GROUP_COMPLETE = exports.PUT_TO_MOVE_CONTENT_NEW_GROUP_START = exports.SET_LIMITED_AUDIENCE_COMPLETE = exports.POST_TO_CHANNEL_PROFILE_FAILURE = exports.POST_TO_CHANNEL_PROFILE_COMPLETE = exports.POST_TO_CHANNEL_PROFILE_START = exports.NO_GROUP_DATA = exports.GET_CHANNEL_GROUP_DATA_FAILURE = exports.GET_CHANNEL_GROUP_DATA_COMPLETE = exports.GET_CHANNEL_GROUP_DATA_START = exports.GET_FEATURED_CONTENT_LIST_FAILURE = exports.GET_FEATURED_CONTENT_LIST_COMPLETE = exports.GET_FEATURED_CONTENT_LIST_START = exports.UNAUTH_CHANNEL_PROFILE_RESOLVE = exports.GET_CHANNEL_PROFILE_FAILURE = exports.GET_CHANNEL_PROFILE_COMPLETE = exports.GET_CHANNEL_PROFILE_START = exports.GET_CONTENT_ID_LIST_FAILURE = exports.GET_CONTENT_ID_LIST_COMPLETE = exports.GET_CONTENT_ID_LIST_START = exports.GET_CHANNELS_FAILURE = exports.GET_CHANNELS_COMPLETE = exports.GET_CHANNELS_START = undefined;
exports.getChannels = getChannels;
exports.getContentIds = getContentIds;
exports.getChannelProfile = getChannelProfile;
exports.getFeaturedContentList = getFeaturedContentList;
exports.getGroupData = getGroupData;
exports.createGroup = createGroup;
exports.putChannelTheme = putChannelTheme;
exports.putChannelTitle = putChannelTitle;
exports.putChannelDescription = putChannelDescription;
exports.putChannelBanner = putChannelBanner;
exports.putChannelLogo = putChannelLogo;
exports.putChannelMoveGroups = putChannelMoveGroups;
exports.putFeaturedContent = putFeaturedContent;
exports.moveContentsToAnotherGroup = moveContentsToAnotherGroup;
exports.moveContentToAnotherGroup = moveContentToAnotherGroup;
exports.moveContentWithinGroup = moveContentWithinGroup;
exports.addContentToNewGroup = addContentToNewGroup;
exports.putChannelGroup = putChannelGroup;
exports.dispatchDeleteDataError = dispatchDeleteDataError;
exports.deleteGroup = deleteGroup;
exports.channelProfileErrorHandled = channelProfileErrorHandled;
exports.resetChannelState = resetChannelState;
exports.setLimitedAudience = setLimitedAudience;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

var _themeSelectorHelper = require('../../helpers/theme-selector-helper');

var themeSelectorHelper = _interopRequireWildcard(_themeSelectorHelper);

var _dragAndDropHelper = require('../../helpers/drag-and-drop-helper');

var _groupsHelper = require('../../helpers/groups-helper');

var groupsHelper = _interopRequireWildcard(_groupsHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Action Types

// Helpers


// READ CHANNELS
var GET_CHANNELS_START = exports.GET_CHANNELS_START = 'GET_CHANNELS_START';
var GET_CHANNELS_COMPLETE = exports.GET_CHANNELS_COMPLETE = 'GET_CHANNELS_COMPLETE';
var GET_CHANNELS_FAILURE = exports.GET_CHANNELS_FAILURE = 'GET_CHANNELS_FAILURE';

// GET
var GET_CONTENT_ID_LIST_START = exports.GET_CONTENT_ID_LIST_START = 'GET_CONTENT_ID_LIST_START';
var GET_CONTENT_ID_LIST_COMPLETE = exports.GET_CONTENT_ID_LIST_COMPLETE = 'GET_CONTENT_ID_LIST_COMPLETE';
var GET_CONTENT_ID_LIST_FAILURE = exports.GET_CONTENT_ID_LIST_FAILURE = 'GET_CONTENT_ID_LIST_FAILURE';

var GET_CHANNEL_PROFILE_START = exports.GET_CHANNEL_PROFILE_START = 'GET_CHANNEL_PROFILE_START';
var GET_CHANNEL_PROFILE_COMPLETE = exports.GET_CHANNEL_PROFILE_COMPLETE = 'GET_CHANNEL_PROFILE_COMPLETE';
var GET_CHANNEL_PROFILE_FAILURE = exports.GET_CHANNEL_PROFILE_FAILURE = 'GET_CHANNEL_PROFILE_FAILURE';
var UNAUTH_CHANNEL_PROFILE_RESOLVE = exports.UNAUTH_CHANNEL_PROFILE_RESOLVE = 'UNAUTH_CHANNEL_PROFILE_RESOLVE';
var GET_FEATURED_CONTENT_LIST_START = exports.GET_FEATURED_CONTENT_LIST_START = 'GET_FEATURED_CONTENT_LIST_START';
var GET_FEATURED_CONTENT_LIST_COMPLETE = exports.GET_FEATURED_CONTENT_LIST_COMPLETE = 'GET_FEATURED_CONTENT_LIST_COMPLETE';
var GET_FEATURED_CONTENT_LIST_FAILURE = exports.GET_FEATURED_CONTENT_LIST_FAILURE = 'GET_FEATURED_CONTENT_LIST_FAILURE';

var GET_CHANNEL_GROUP_DATA_START = exports.GET_CHANNEL_GROUP_DATA_START = 'GET_CHANNEL_GROUP_DATA_START';
var GET_CHANNEL_GROUP_DATA_COMPLETE = exports.GET_CHANNEL_GROUP_DATA_COMPLETE = 'GET_CHANNEL_GROUP_DATA_COMPLETE';
var GET_CHANNEL_GROUP_DATA_FAILURE = exports.GET_CHANNEL_GROUP_DATA_FAILURE = 'GET_CHANNEL_GROUP_DATA_FAILURE';
var NO_GROUP_DATA = exports.NO_GROUP_DATA = 'NO_GROUP_DATA';

// POST
var POST_TO_CHANNEL_PROFILE_START = exports.POST_TO_CHANNEL_PROFILE_START = 'POST_TO_CHANNEL_PROFILE_START';
var POST_TO_CHANNEL_PROFILE_COMPLETE = exports.POST_TO_CHANNEL_PROFILE_COMPLETE = 'POST_TO_CHANNEL_PROFILE_COMPLETE';
var POST_TO_CHANNEL_PROFILE_FAILURE = exports.POST_TO_CHANNEL_PROFILE_FAILURE = 'POST_TO_CHANNEL_PROFILE_FAILURE';
var SET_LIMITED_AUDIENCE_COMPLETE = exports.SET_LIMITED_AUDIENCE_COMPLETE = 'SET_LIMITED_AUDIENCE_COMPLETE';

// PUT MOVE/COPY
var PUT_TO_MOVE_CONTENT_NEW_GROUP_START = exports.PUT_TO_MOVE_CONTENT_NEW_GROUP_START = 'PUT_TO_MOVE_CONTENT_NEW_GROUP_START';
var PUT_TO_MOVE_CONTENT_NEW_GROUP_COMPLETE = exports.PUT_TO_MOVE_CONTENT_NEW_GROUP_COMPLETE = 'PUT_TO_MOVE_CONTENT_NEW_GROUP_COMPLETE';
var PUT_TO_MOVE_CONTENT_NEW_GROUP_FAILURE = exports.PUT_TO_MOVE_CONTENT_NEW_GROUP_FAILURE = 'PUT_TO_MOVE_CONTENT_NEW_GROUP_FAILURE';
var PUT_TO_MOVE_CONTENT_WITHIN_GROUP_START = exports.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_START = 'PUT_TO_MOVE_CONTENT_WITHIN_GROUP_START';
var PUT_TO_MOVE_CONTENT_WITHIN_GROUP_COMPLETE = exports.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_COMPLETE = 'PUT_TO_MOVE_CONTENT_WITHIN_GROUP_COMPLETE';
var PUT_TO_MOVE_CONTENT_WITHIN_GROUP_FAILURE = exports.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_FAILURE = 'PUT_TO_MOVE_CONTENT_WITHIN_GROUP_FAILURE';
var MOVE_CONTENTS_ANOTHER_GROUP_START = exports.MOVE_CONTENTS_ANOTHER_GROUP_START = 'MOVE_CONTENTS_ANOTHER_GROUP_START';
var MOVE_CONTENTS_ANOTHER_GROUP_COMPLETE = exports.MOVE_CONTENTS_ANOTHER_GROUP_COMPLETE = 'MOVE_CONTENTS_ANOTHER_GROUP_COMPLETE';
var PUT_TO_ADD_CONTENT_COMPLETE = exports.PUT_TO_ADD_CONTENT_COMPLETE = 'PUT_TO_ADD_CONTENT_COMPLETE';
var PUT_TO_ADD_CONTENT_START = exports.PUT_TO_ADD_CONTENT_START = 'PUT_TO_ADD_CONTENT_START';
var PUT_TO_ADD_CONTENT_FAILURE = exports.PUT_TO_ADD_CONTENT_FAILURE = 'PUT_TO_ADD_CONTENT_FAILURE';

// POST CREATE GROUP
var POST_CHANNEL_GROUP_START = exports.POST_CHANNEL_GROUP_START = 'POST_CHANNEL_GROUP_START';
var POST_CHANNEL_GROUP_COMPLETE = exports.POST_CHANNEL_GROUP_COMPLETE = 'POST_CHANNEL_GROUP_COMPLETE';
var POST_CHANNEL_GROUP_FAILURE = exports.POST_CHANNEL_GROUP_FAILURE = 'POST_CHANNEL_GROUP_FAILURE';

// PUT
var PUT_TO_FEATURE_CONTENT_START = exports.PUT_TO_FEATURE_CONTENT_START = 'PUT_TO_FEATURE_CONTENT_START';
var PUT_TO_FEATURE_CONTENT_COMPLETE = exports.PUT_TO_FEATURE_CONTENT_COMPLETE = 'PUT_TO_FEATURE_CONTENT_COMPLETE';
var PUT_TO_FEATURE_CONTENT_FAILURE = exports.PUT_TO_FEATURE_CONTENT_FAILURE = 'PUT_TO_FEATURE_CONTENT_FAILURE';

var PUT_TO_CHANNEL_GROUP_START = exports.PUT_TO_CHANNEL_GROUP_START = 'PUT_TO_CHANNEL_GROUP_START';
var PUT_TO_CHANNEL_GROUP_COMPLETE = exports.PUT_TO_CHANNEL_GROUP_COMPLETE = 'PUT_TO_CHANNEL_GROUP_COMPLETE';
var PUT_TO_CHANNEL_GROUP_FAILURE = exports.PUT_TO_CHANNEL_GROUP_FAILURE = 'PUT_TO_CHANNEL_GROUP_FAILURE';

// DELETE GROUP
var DELETE_CHANNEL_GROUP_START = exports.DELETE_CHANNEL_GROUP_START = 'DELETE_CHANNEL_GROUP_START';
var DELETE_CHANNEL_GROUP_COMPLETE = exports.DELETE_CHANNEL_GROUP_COMPLETE = 'DELETE_CHANNEL_GROUP_COMPLETE';

// RESET
var RESET_CHANNEL_STATE = exports.RESET_CHANNEL_STATE = 'RESET_CHANNEL_STATE';

// error Handlers
var CHANNEL_PROFILE_ERROR_HANDLED = exports.CHANNEL_PROFILE_ERROR_HANDLED = 'CHANNEL_PROFILE_ERROR_HANDLED';

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------


var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------

var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('action-channel-profile');
    }
    logger.error(msg, attributes);
}

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Token ' + state.auth.authInfo.access_token;
    }

    return header;
}

// ------------------------------------------------------------------ READ CALLS ------------------------------------------------------------------

function getChannels() {
    var reqUrl = baseUrl() + '/channels';

    return function (dispatch, getState) {
        var store = getState();
        var header = getheader(store);

        dispatch({ type: GET_CHANNELS_START });

        return HTTP.getData(reqUrl, header).then(function (channels) {
            dispatch({ type: GET_CHANNELS_COMPLETE, channels: channels });
            return Promise.resolve(channels);
        }).catch(function (error) {
            loggingHelper('get channels fetch failed', { method: 'getChannels', callType: 'GET', error: error });
            dispatch({ type: GET_CHANNELS_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}

function getContentIds(channelId) {
    var reqUrl = baseUrl() + '/channels/' + channelId + '/contents';

    return function (dispatch, getState) {
        dispatch({ type: GET_CONTENT_ID_LIST_START });

        return HTTP.getData(reqUrl).then(function (response) {
            dispatch({ type: GET_CONTENT_ID_LIST_COMPLETE, response: response });
        }).catch(function (error) {
            loggingHelper('get content ids fetch failed', { method: 'getContentIds', callType: 'GET', channelId: channelId, error: error });
            dispatch({ type: GET_CONTENT_ID_LIST_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}

function getChannelProfile(channelId, needsAuth) {
    var reqUrl = baseUrl() + '/channels/' + channelId;

    return function (dispatch, getState) {
        var state = getState();
        var header = needsAuth ? getheader(state) : getheader();
        dispatch({ type: GET_CHANNEL_PROFILE_START });

        return HTTP.getData(reqUrl, header).then(function (response) {
            response.channelTheme = themeSelectorHelper.themeParsing(response.channelTheme);
            response.channelThemeTextColor = themeSelectorHelper.themeColorLightness(response.channelTheme);
            dispatch({ type: GET_CHANNEL_PROFILE_COMPLETE, response: response });
            return Promise.resolve(response);
        }).catch(function (error) {
            if (error.status === 403) {
                dispatch({ type: UNAUTH_CHANNEL_PROFILE_RESOLVE, error: error });
                return Promise.resolve(error);
            }
            loggingHelper('get channel profile fetch failed', { method: 'getChannelProfile', callType: 'GET', channelId: channelId, error: error });
            dispatch({ type: GET_CHANNEL_PROFILE_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}

function getFeaturedContentList(channelId) {
    var reqUrl = baseUrl() + '/channels/' + channelId + '/contents?featured=true';

    return function (dispatch, getState) {
        dispatch({ type: GET_FEATURED_CONTENT_LIST_START });

        return HTTP.getData(reqUrl).then(function (response) {
            dispatch({ type: GET_FEATURED_CONTENT_LIST_COMPLETE, response: response });
        }).catch(function (error) {
            loggingHelper('get featured contents fetch failed', { method: 'getFeaturedContentList', callType: 'GET', channelId: channelId, error: error });
            dispatch({ type: GET_FEATURED_CONTENT_LIST_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}

function getGroupData(channelKey, groupKeys) {
    var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups?keys=' + groupKeys;

    return function (dispatch, getState) {
        dispatch({ type: GET_CHANNEL_GROUP_DATA_START });

        return HTTP.getData(reqUrl).then(function (response) {
            dispatch({ type: GET_CHANNEL_GROUP_DATA_COMPLETE, response: response });
            if (response && response.length === 0) {
                dispatch({ type: NO_GROUP_DATA });
            }
            return Promise.resolve(response);
        }).catch(function (error) {
            loggingHelper('get Group list failed', { method: 'getGroupData', callType: 'GET', channelKey: channelKey, error: error });
            dispatch({ type: GET_CHANNEL_GROUP_DATA_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}

// ------------------------------------------------------------------ CREATE CALLS ------------------------------------------------------------------

function createGroup(channelKey, groupName) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups';
        var store = getStore();
        var header = getheader(store);

        var postBody = { groupName: groupName };

        dispatch({ type: POST_CHANNEL_GROUP_START });

        return HTTP.postData(reqUrl, header, postBody).then(function (response) {
            dispatch({ type: POST_CHANNEL_GROUP_COMPLETE, response: response, groupName: groupName });
        }).catch(function (error) {
            loggingHelper('create group post failed', { method: 'createGroup', callType: 'POST', groupName: groupName, error: error });
            dispatch({ type: POST_CHANNEL_GROUP_FAILURE, error: error, dataCall: 'createGroup' });
        });
    };
}

// ------------------------------------------------------------------ UPDATE CALLS ------------------------------------------------------------------

function putChannelTheme(channelKey, channelTheme) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { channelTheme: channelTheme };
        var channelThemeTextColor = themeSelectorHelper.themeColorLightness(channelTheme);
        dispatch({ type: POST_TO_CHANNEL_PROFILE_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (content) {
            dispatch({ type: POST_TO_CHANNEL_PROFILE_COMPLETE, channelTheme: channelTheme, channelThemeTextColor: channelThemeTextColor });
        }).catch(function (error) {
            loggingHelper('applying a new channel theme failed', { method: 'putChannelTheme', callType: 'PUT', channelKey: channelKey, channelTheme: channelTheme, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'putChannelTheme' });
        });
    };
}

function putChannelTitle(channelKey, channelTitle) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { channelTitle: channelTitle };

        dispatch({ type: POST_TO_CHANNEL_PROFILE_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (content) {
            dispatch({ type: POST_TO_CHANNEL_PROFILE_COMPLETE, channelTitle: channelTitle });
        }).catch(function (error) {
            loggingHelper('applying a new channel title failed', { method: 'putChannelTitle', callType: 'PUT', channelKey: channelKey, channelTitle: channelTitle, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'putChannelTitle' });
        });
    };
}

function putChannelDescription(channelKey, channelDescription) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { channelDescription: channelDescription };

        dispatch({ type: POST_TO_CHANNEL_PROFILE_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (content) {
            dispatch({ type: POST_TO_CHANNEL_PROFILE_COMPLETE, channelDescription: channelDescription });
        }).catch(function (error) {
            loggingHelper('applying a new channel description failed', { method: 'putChannelDescription', callType: 'PUT', channelKey: channelKey, channelDescription: channelDescription, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'putChannelDescription' });
        });
    };
}

function putChannelBanner(channelKey, channelBanner) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { channelBanner: channelBanner };

        dispatch({ type: POST_TO_CHANNEL_PROFILE_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (content) {
            dispatch({ type: POST_TO_CHANNEL_PROFILE_COMPLETE, channelBanner: channelBanner });
        }).catch(function (error) {
            loggingHelper('applying a new channel banner failed', { method: 'putChannelBanner', callType: 'PUT', channelKey: channelKey, channelBanner: channelBanner, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'putChannelBanner' });
        });
    };
}

function putChannelLogo(channelKey, channelLogo) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { channelLogo: channelLogo };

        dispatch({ type: POST_TO_CHANNEL_PROFILE_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (content) {
            dispatch({ type: POST_TO_CHANNEL_PROFILE_COMPLETE, channelLogo: channelLogo });
        }).catch(function (error) {
            loggingHelper('applying a new channel logo failed', { method: 'putChannelLogo', callType: 'PUT', channelKey: channelKey, channelLogo: channelLogo, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'putChannelLogo' });
        });
    };
}

function putChannelMoveGroups(channelKey, groupKeys) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { groupKeys: groupKeys };

        dispatch({ type: POST_TO_CHANNEL_PROFILE_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (content) {
            dispatch({ type: POST_TO_CHANNEL_PROFILE_COMPLETE, groupKeys: groupKeys });
        }).catch(function (error) {
            loggingHelper('moving groups failed', { method: 'putChannelMoveGroups', callType: 'PUT', channelKey: channelKey, groupKeys: groupKeys, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'putChannelMoveGroups' });
        });
    };
}

function putFeaturedContent(channelKey, contentKey, body) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/contents/' + contentKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = {};
        if (body === true || body === false) {
            reqBody.featured = body;
        }

        dispatch({ type: PUT_TO_FEATURE_CONTENT_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (response) {
            var status = {
                feature: reqBody.featured,
                contentKey: contentKey
            };
            dispatch({ type: PUT_TO_FEATURE_CONTENT_COMPLETE, status: status });
        }).catch(function (error) {
            loggingHelper('failed to feature a content', { method: 'putFeaturedContent', callType: 'PUT', channelKey: channelKey, contentKey: contentKey, featureBody: body, error: error });
            dispatch({ type: PUT_TO_FEATURE_CONTENT_FAILURE, error: error, body: body, dataCall: 'putFeaturedContent' });
        });
    };
}
// --------------------------------------------------Moving contents-------------------------------------------------------
function moveContentsToAnotherGroup(channelKey, srcGroupKey, destGroupKey, contentKeys) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups/' + srcGroupKey + '/contents/move';
        var store = getStore();
        // Make a deep copy of the original group data
        var newGroupData = [].concat(_toConsumableArray(store.channel.groupData));
        var destContentKeysArray = groupsHelper.getDestinationContentKeys(destGroupKey, contentKeys, newGroupData);
        var contentKeysCopy = contentKeys.slice();
        groupsHelper.updateGroupData(newGroupData, contentKeys, srcGroupKey, destGroupKey, destContentKeysArray);

        dispatch({ type: MOVE_CONTENTS_ANOTHER_GROUP_START, groupData: newGroupData });
        var header = getheader(store);
        var reqBody = {
            contentKeys: contentKeysCopy,
            destination: {
                resource: '/channels/' + channelKey + '/groups/' + destGroupKey,
                contentKeys: destContentKeysArray
            } };

        return HTTP.putData(reqUrl, header, reqBody).then(function () {
            dispatch({ type: MOVE_CONTENTS_ANOTHER_GROUP_COMPLETE });
        }).catch(function (error) {
            loggingHelper('failed to move contents to another group', { method: 'moveContentsToAnotherGroup', callType: 'PUT', srcGroupKey: srcGroupKey, destGroupKey: destGroupKey, contentKeys: contentKeys, error: error });
            return Promise.reject(error);
        });
    };
}

function moveContentToAnotherGroup(channelKey, srcGroupKey, destGroupKey, contentToMove, siblingContent) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups/' + srcGroupKey + '/contents/move';
        var store = getStore();
        // Make a deep copy of the original group data
        var originalGroupData = JSON.parse(JSON.stringify(store.channel.groupData));
        var newGroupData = [].concat(_toConsumableArray(store.channel.groupData));
        var header = getheader(store);
        var destContentKeysArray = (0, _dragAndDropHelper.getDestContentKeys)(contentToMove, srcGroupKey, destGroupKey, newGroupData, siblingContent);
        var reqBody = {
            contentKeys: [contentToMove],
            destination: {
                resource: '/channels/' + channelKey + '/groups/' + destGroupKey,
                contentKeys: destContentKeysArray
            }
        };

        newGroupData.forEach(function (item) {
            if (item.groupKey === srcGroupKey) {
                // Remove the groupkey from the src group array during a content move operation
                item.contentKeys.splice(item.contentKeys.indexOf(contentToMove), 1);
            }
            if (item.groupKey === destGroupKey) {
                item.contentKeys = destContentKeysArray;
            }
        });
        dispatch({ type: PUT_TO_MOVE_CONTENT_NEW_GROUP_START, groupData: newGroupData });

        return HTTP.putData(reqUrl, header, reqBody).then(function (response) {
            dispatch({ type: PUT_TO_MOVE_CONTENT_NEW_GROUP_COMPLETE });
        }).catch(function (error) {
            loggingHelper('failed to move content to a new group', { method: 'moveContentToAnotherGroup', callType: 'PUT', srcGroupKey: srcGroupKey, destGroupKey: destGroupKey, contentToMove: contentToMove, error: error });
            dispatch({ type: PUT_TO_MOVE_CONTENT_NEW_GROUP_FAILURE, groupData: originalGroupData, error: error, dataCall: 'moveContentToAnotherGroup' });
        });
    };
}

function moveContentWithinGroup(channelKey, srcGroupKey, destGroupKey, contentToMove, siblingContent) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups/' + srcGroupKey;
        var store = getStore();
        // Make a deep copy of the original group data
        var originalGroupData = JSON.parse(JSON.stringify(store.channel.groupData));
        var newGroupData = [].concat(_toConsumableArray(store.channel.groupData));
        var header = getheader(store);
        var destContentKeysArray = (0, _dragAndDropHelper.getDestContentKeys)(contentToMove, srcGroupKey, destGroupKey, newGroupData, siblingContent);
        var reqBody = {
            contentKeys: destContentKeysArray
        };

        newGroupData.forEach(function (item) {
            if (item.groupKey === destGroupKey) {
                item.contentKeys = destContentKeysArray;
            }
        });
        dispatch({ type: PUT_TO_MOVE_CONTENT_WITHIN_GROUP_START, groupData: newGroupData });

        return HTTP.putData(reqUrl, header, reqBody).then(function (response) {
            dispatch({ type: PUT_TO_MOVE_CONTENT_WITHIN_GROUP_COMPLETE });
        }).catch(function (error) {
            loggingHelper('failed to move content within a group', { method: 'moveContentWithinGroup', callType: 'PUT', srcGroupKey: srcGroupKey, destGroupKey: destGroupKey, contentToMove: contentToMove, error: error });
            dispatch({ type: PUT_TO_MOVE_CONTENT_WITHIN_GROUP_FAILURE, groupData: originalGroupData, error: error, dataCall: 'moveContentWithinGroup' });
        });
    };
}

function addContentToNewGroup(channelKey, destGroupKey, contentToAdd) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups/' + destGroupKey;
        var store = getStore();
        var groupData = store.channel.groupData;
        var header = getheader(store);
        var destContentKeysArray = (0, _dragAndDropHelper.getDestContentKeys)(contentToAdd, destGroupKey, groupData);
        var reqBody = {
            contentKeys: destContentKeysArray
        };

        dispatch({ type: PUT_TO_ADD_CONTENT_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (response) {
            groupData.forEach(function (item) {
                if (item.groupKey === destGroupKey) {
                    item.contentKeys = destContentKeysArray;
                }
            });
            dispatch({ type: PUT_TO_ADD_CONTENT_COMPLETE, groupData: groupData });
        }).catch(function (error) {
            loggingHelper('failed to add/copy content to a new group', { method: 'addContentToNewGroup', callType: 'PUT', destGroupKey: destGroupKey, contentToAdd: contentToAdd, error: error });
            dispatch({ type: PUT_TO_ADD_CONTENT_FAILURE, error: error, dataCall: 'addContentToNewGroup' });
        });
    };
}

function putChannelGroup(channelKey, groupKey, groupName) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups/' + groupKey;
        var store = getStore();
        var header = getheader(store);
        var reqBody = { groupName: groupName };

        dispatch({ type: PUT_TO_CHANNEL_GROUP_START });

        return HTTP.putData(reqUrl, header, reqBody).then(function (response) {
            dispatch({ type: PUT_TO_CHANNEL_GROUP_COMPLETE, groupName: groupName, groupKey: groupKey });
        }).catch(function (error) {
            loggingHelper('updating group Name failed', { method: 'putChannelGroup', callType: 'PUT', channelKey: channelKey, groupKey: groupKey, groupName: groupName, error: error });
            dispatch({ type: POST_CHANNEL_GROUP_FAILURE, error: error, dataCall: 'putChannelGroup' });
        });
    };
}

// ------------------------------------------------------------------ DELETE CALLS ------------------------------------------------------------------

function dispatchDeleteDataError(error) {
    return function (dispatch) {
        dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'deleteGroup' });
    };
}

function deleteGroup(channelKey, groupKey) {
    return function (dispatch, getStore) {
        var reqUrl = baseUrl() + '/channels/' + channelKey + '/groups/' + groupKey;
        var store = getStore();
        var header = getheader(store);

        dispatch({ type: DELETE_CHANNEL_GROUP_START });

        return HTTP.deleteData(reqUrl, header).then(function (response) {
            dispatch({ type: DELETE_CHANNEL_GROUP_COMPLETE, response: response, groupKey: groupKey });
            return Promise.resolve(response);
        }).catch(function (error) {
            loggingHelper('delete group failed', { method: 'deleteGroup', callType: 'DELETE', groupKey: groupKey, error: error });
            dispatch({ type: POST_TO_CHANNEL_PROFILE_FAILURE, error: error, dataCall: 'deleteGroup' });
            return Promise.reject(error);
        });
    };
}

function channelProfileErrorHandled() {
    return function (dispatch) {
        dispatch({ type: CHANNEL_PROFILE_ERROR_HANDLED });
    };
}

function resetChannelState() {
    return function (dispatch, getStore) {
        dispatch({ type: RESET_CHANNEL_STATE });
    };
}

function setLimitedAudience(isLimitedAudience) {
    return function (dispatch, getStore) {
        dispatch({ type: SET_LIMITED_AUDIENCE_COMPLETE, isLimitedAudience: isLimitedAudience });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/channel-profile.js
// module id = 760
// module chunks = 0